var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{attrs:{"right":"","title":_vm.$t('Legal Warning')},on:{"click":_vm.showLegal}},[_c('feather-icon',{staticClass:"text-body",attrs:{"icon":"InfoIcon","size":"21"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }